/**
 * Guard per il conflitto noto tra Google Translate (widget sito) e React.
 *
 * Il widget GT wrappa i nodi di testo in <font>/sostituisce nodi nel DOM reale.
 * Quando React poi ri-renderizza e tenta removeChild/insertBefore su nodi che
 * GT ha già spostato, il browser lancia NotFoundError e l'ErrorBoundary
 * smonta l'intera pagina ("Qualcosa non ha caricato correttamente").
 *
 * La patch — pattern consolidato per SPA + Google Translate — rende le due
 * operazioni tolleranti al mismatch di parent: React continua e GT mantiene
 * la traduzione. Nessun effetto quando GT non è attivo.
 */
export function installGoogleTranslateDomGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;
  const proto = Node.prototype;
  if (proto.__gtGuardInstalled) return;
  proto.__gtGuardInstalled = true;

  const origRemoveChild = proto.removeChild;
  proto.removeChild = function removeChild(child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return origRemoveChild.call(this, child);
  };

  const origInsertBefore = proto.insertBefore;
  proto.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return origInsertBefore.call(this, newNode, null);
    }
    return origInsertBefore.call(this, newNode, referenceNode);
  };
}
